import React from 'react';
import { injectIntl } from 'react-intl';
import { useApolloClient } from '@apollo/client';

import { withStations } from 'components/queries/GetStationsQuery';
import { GET_CACHED_SEARCH_PARAMS } from 'store/queries';

import { withBooking } from 'components/queries/GetBookingQuery';
import { withUser } from 'components/queries/GetUserQuery';
import BookingMagnet from './BookingMagnetMultiJourney';

const BookingMagnetQuery = (props) => {
  const client = useApolloClient();

  const searchParamsData = client.readQuery({
    query: GET_CACHED_SEARCH_PARAMS
  });

  return <BookingMagnet client={client} searchParams={searchParamsData?.searchParams} {...props} />;
};

export default withStations(withBooking(withUser(injectIntl(BookingMagnetQuery))));
